module.exports = __webpack_public_path__ + "img/sixpackcarrier53.e81c0520.jpg";